@if(!isHealthy) {
	<div class="alert alert-warning push-status-message-container" role="alert">
		<span class="warning">
			{{ 'ConnectionError_Warning' | translate }}
		</span>
	</div>
}
